import { getPayouts } from "@/services/transactions.service";
import { useQuery } from "@tanstack/react-query";

export const usePayouts = (
  enabled = true,
  params = { page: 0, size: 20 },
  options = {},
) => {
  const queryKey = ["payouts", params.page, params.size, params.status, params.search];

  return useQuery({
    queryKey,
    queryFn: () => getPayouts(params),
    enabled,
    ...options,
  });
};
